<template>
    <div 
        class="o-p-map-icons"
        :style="componentStyles"
    >
        <div class="o-p-map-icons__icon-wrapper">
            <AServiceButton
                v-for="(item, index) in icons"
                :key="index"
                :item="item"
            />
        </div>
        <!-- <div class="o-p-map-icons__icon-wrapper">
            <AServiceButton
                v-for="(item, index) in icons"
                :key="index"
                :item="item"
                :isShowTitle="false"
            />
        </div> -->
        
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AServiceButton from '../../atoms/a-service-button/a-service-button';

export default {
    name: 'OPMapIcons',
    components: {
        AServiceButton
    },
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp', 'getOrderedServiceCategories'
        ]),
        commonConfigStyles() {
            return this.getMapConfigProp('components.OPMapIcons.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.OPMapIcons.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        icons() {
            return this.getOrderedServiceCategories.slice(0, 12);
        },
    }
}
</script>

<style lang="scss">
@import "o-p-map-icons";
</style>